import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    row: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f4f6f8',
        },
    },
    messageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '300px',
        flexDirection: 'column',
        gap: '20px',
        textAlign: 'center',
    },
});
